import React from "react";
import Link from '../../routing/components/Link';
import {FormattedMessage} from 'react-intl';

class TagBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };

    this.switchExpanded = this.switchExpanded.bind(this);
  }

  switchExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  render() {
    let {switchExpanded} = this;
    let {tags, tagUrl, maxTags} = this.props;
    let {expanded} = this.state;
    if (tags && tags.length > 0) {
      let tagElements = tags.sort(function (a, b) {
        return a.value.toLowerCase().trim().localeCompare(b.value.toLowerCase().trim());
      }).filter((tag, i, arr) => {
        if (i > 0 && arr[i - 1].value === tag.value) {
          return false;
        }
        return true;
      })
        .map((tag, i) => <Link key={i} url={tagUrl(tag)}>{tag.value}</Link>);
      let tagValues = [];
      let tagsShown = expanded ? tagElements.length : Math.min(tagElements.length, maxTags);
      for (let i = 0; i < tagsShown; i++) {
        tagValues.push(tagElements[i]);
        if (i < tagsShown - 1) {
          tagValues.push(', ');
        }
      }
      if (tagElements.length > maxTags) {
        tagValues.push(expanded ? '. ' : ', ... ');
        tagValues.push(<a key="showmore" href="#tags" style={{fontStyle: 'italic'}} onClick={switchExpanded}>(<FormattedMessage
          id={expanded ? 'showLess' : 'showMore'}/>)</a>);
      }
      return (
        <table className="tagTable" style={{marginBottom: 32}}>
          <tbody>
          <tr>
            <td>
              <FormattedMessage id="tags"/>:
            </td>
            <td>
              {tagValues}
            </td>
          </tr>
          </tbody>
        </table>
      );
    }
    return null;
  }
}

TagBar.propTypes = {
  tags: React.PropTypes.array,
  tagUrl: React.PropTypes.func.isRequired,
  maxTags: React.PropTypes.number
};

TagBar.defaultProps = {
  maxTags: 5
};

export default TagBar;



/** WEBPACK FOOTER **
 ** ./src/modules/tags/components/TagBar.js
 **/